<template>
  <div class="fa">
    <div>
      <div class="top-btn">
        <div class="top-btn-danju">
          <!-- <el-select size="small" v-model="field1" placeholder="模糊查询">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> -->
          <el-input
            size="small"
            placeholder="模糊查询,空则显示全部"
            v-model="search_value"
            class="input-with-select"
          >
            <el-button
              slot="append"
              type="primary"
              icon="el-icon-search"
              @click="searchGoods()"
            ></el-button>
          </el-input>
        </div>

        <div>
          <el-button size="mini" @click="daoRu" type="primary"
            >导入excel</el-button
          >
          <el-button
            size="mini"
            @click="checkModify('DialogVisible')"
            type="info"
            >批量修改</el-button
          >

          <el-button size="mini" @click="addGoods" type="success"
            >添加</el-button
          >
          <el-button
            size="mini"
            @click="checkModify('bulkModify')"
            type="warning"
            >格式化售价</el-button
          >
          <el-button size="mini" @click="deleteChecked" type="danger"
            >删除选中</el-button
          >

          <el-button size="mini" type="info" @click="exportXML">导出</el-button>
          <el-button size="mini" type="primary" @click="saveUpdate"
            >导入泰格</el-button
          >
          <!-- 
          
          <el-button size="mini" class="info-btn" type="success">提交</el-button> -->
        </div>
      </div>
      <!-- 表格内容 -->
      <ve-table
        id="loading-container"
        border-x
        border-y
        :columns="columns"
        :fixed-header="true"
        style="width: 100%"
        :scroll-width="1500"
        v-if="goodsDataShow"
        :maxHeight="`${tbmax_height}px`"
        rowKeyFieldName="rowKey"
        :table-data="goods_list"
        :editOption="editOption"
        :sort-option="sortOption"
        :checkbox-option="checkboxOption"
        :rowStyleOption="rowStyleOption"
        :cell-style-option="cellStyleOption"
        :event-custom-option="eventCustomOption"
        :virtual-scroll-option="virtualScrollOption"
        enable="true"
      />
    </div>
    <!-- 导入的组件 -->
    <excel
      ref="excel"
      @FileName="FileName"
      @cover-import="CoverTableData"
      @update-import="updateTableData"
    >
      更新并导入
    </excel>

    <!-- 批量修改 -->
    <el-dialog
      title="批量修改选中商品的信息"
      :visible.sync="DialogVisible"
      width="600px"
      center
    >
      <el-form label-width="120px">
        <el-form-item label="字段名：">
          <el-select
            style="width: 300px"
            v-model="dialogValue"
            filterable
            placeholder="请选择需要修改的字段名"
          >
            <el-option
              v-for="item in dialogColumn"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="dialogValue != 'class_no' && dialogValue != 'sup_no'"
          label="修改为："
        >
          <el-input
            style="width: 300px"
            placeholder="输入修改后的值"
            v-model="dialog_change"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="dialogValue == 'class_no'" label="选择类别：">
          <wty-select
            id="1"
            :width="300"
            :who="dialogValue"
            @getReturn="getReturn"
          ></wty-select>
        </el-form-item>
        <el-form-item v-if="dialogValue == 'sup_no'" label="选择供应商：">
          <wty-select
            id="2"
            :width="300"
            :who="dialogValue"
            @getReturn="getReturn"
          ></wty-select>
        </el-form-item>
        <!-- <el-form-item v-if="dialogValue == 'barcode'" label="执行操作：">
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox v-for="item in radioList" :label="item" :key="item">{{
              city
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindDetermine">确 定</el-button>
        <el-button @click="bindCancelTask">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 格式化售价 -->
    <el-dialog
      title="格式化售价"
      :visible.sync="bulkModify"
      width="600px"
      center
    >
      <el-form label-width="150px">
        <el-form-item label="加点数：">
          <el-input
            placeholder="请输入加点数（例如加30个点输入30）"
            v-model="formatsp_data.point"
          ></el-input>
        </el-form-item>
        <el-form-item label="小数点后改为：">
          <div style="display: flex">
            <div
              style="margin-right: 10px"
              v-for="(item, index) in formatsp_data.change_to"
              :key="index"
            >
              <el-input
                style="width: 50px"
                type="text"
                v-model="formatsp_data.change_to[index]"
              ></el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formatSalePrice">确 定</el-button>
        <el-button @click="bindCancelTask">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  exportExcel,
  openDownloadDialog,
  workbook2blob,
} from "@/js/exportExcel.js";
import excel from "@/components/excel.vue";
import { goodsInsertItem } from "@/api/offlinestores.js";
import WtySelect from "@/components/wty-select.vue";
// import wtyRadio from "@/components/wty-radio";
export default {
  components: { excel, WtySelect },
  computed: {
    editableTabsValue() {
      return this.$store.state.home.editableTabsValue;
    },
    /* mainH() {
      return this.$store.state.resolution.mainH;
    }, */
    innerWH() {
      return this.$store.state.resolution.innerWH;
    },
  },
  watch: {
    innerWH: {
      handler(newH, oldH) {
        this.tbmax_height = newH.innerHeight - 75;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      select_classno: "",
      loadingInstance: null,
      tbmax_height: "500",
      bulkModify: false,
      file_name: "",
      sub_data: {
        barcode: "",
        item_name: "",
        sub_name: "",
        sale_price: "",
        pym: "",
        class_id: "",
        unit: "",
        grade: "",
        product_area: "",
        item_size: "",
        life_day: "",
        brand_name: "",
        oper_id: "",
        merchant_id: "",
        oper_date: "",
        img: [],
      },
      // 是否显示dialog
      DialogVisible: false,
      dialogColumn: [
        {
          label: "条码",
          value: "barcode",
        },
        {
          label: "进价",
          value: "in_price",
        },
        {
          label: "售价",
          value: "sale_price",
        },
        {
          label: "会员价",
          value: "vip_price",
        },
        {
          label: "供应商",
          value: "sup_no",
        },
        {
          label: "类别",
          value: "class_no",
        },
        {
          label: "规格",
          value: "item_size",
        },
        {
          label: "产地",
          value: "product_area",
        },
        {
          label: "单位",
          value: "unit",
        },
        {
          label: "等级",
          value: "grade",
        },
        {
          label: "保质期（天）",
          value: "life_day",
        },
        {
          label: "称重标识",
          value: "weight_flag",
        },
      ],
      dialog_change: "",
      dialogValue: "",
      search_value: "",
      // 表格高度
      // 商品信息的展示
      goodsDataShow: true,
      // 导航菜单
      // 左侧抽屉
      i_class1: "drawer-head-div-i",
      i_class2: "",
      i_class3: "",
      // 右侧抽屉
      drawersTable: false,
      // 树形控件的绑定数组
      treeArray: [
        {
          label: "一级 1",
        },
        {
          label: "一级 2",
        },
        {
          label: "一级 3",
        },
      ],
      tree_Class: [
        {
          label: "一级 1",
        },
        {
          label: "一级 2",
        },
        {
          label: "一级 3",
        },
      ],
      tree_Vendor: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 第一个选择框数据
      options1: [
        {
          value: "0",
          label: "商品名称",
        },
        {
          value: "1",
          label: "类别",
        },
        {
          value: "2",
          label: "供应商",
        },
        {
          value: "3",
          label: "商品条码",
        },
      ],
      // 第二个选择框数据
      options2: [
        {
          value: "0",
          label: "包含",
        },
        {
          value: "1",
          label: "不包含",
        },
        {
          value: "2",
          label: "大于等于",
        },
        {
          value: "3",
          label: "小于等于",
        },
        {
          value: "4",
          label: "等于",
        },
        {
          value: "5",
          label: "不等于",
        },
      ],
      // 导入表格的model
      excel_hide: false,
      // 选择更新或者覆盖的开关
      updateCover: false,
      checkedGoods: [],
      // 表头样式
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      // 排序
      sortOption: {
        sortChange: (params) => {
          console.log("sortChange::", params);
          this.sortChange(params);
        },
      },
      // 商品条码前复选框选中的值
      checkboxOption: {
        // hideSelectAll: true,
        // defaultSelectedRowKeys: ,
        // defaultSelectedAllRows:true,
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          console.log(row, isSelected, selectedRowKeys);
          // row选中行的数据 isSelected 选中的情况(true,false)
          if (isSelected === true) {
            this.checkedGoods.push(row.barcode);
          }
          if (isSelected === false) {
            for (var i = 0; i < this.checkedGoods.length; i++) {
              if (this.checkedGoods[i] === row.barcode) {
                this.checkedGoods.splice(i, 1);
              }
            }
          }
          console.log(this.checkedGoods.length); /* */
          console.log(this.checkedGoods); /* */
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          if (isSelected === true) {
            this.checkedGoods = [];
            for (var i = 0; i < this.goods_list.length; i++) {
              this.checkedGoods[i] = this.goods_list[i].barcode;
            }
          } else {
            this.checkedGoods = [];
          }
        },
        radioList: [
          {
            label: "只保留数字",
            value: "0",
          } /* ,
        {
          label: "正常",
          value: "1"
        },
        {
          label: "休息",
          value: "2"
        } */,
        ],
      },
      // 修改行样式
      // 表格自定义的单机事件
      eventCustomOption: {
        bodyCellEvents: ({ row, column, rowIndex }) => {
          return {
            click: (event) => {
              console.log("click::", row, column, rowIndex, event);
            },
          };
        },
      },
      rowStyleOption: {
        clickHighlight: false,
        stripe: true,
      },
      // 是否开启虚拟滚动
      virtualScrollOption: {
        // 是否开启
        enable: true,
      },
      // edit option 修改后的返回值
      editOption: {
        // cell value change
        cellValueChange: ({ row, column }) => {
          console.log("cellValueChange row::", row);
          console.log("cellValueChange column::", column);
        },
      },
      // 标题表格第一列的信息
      columns: [
        // 标题第一列
        {
          field: "",
          key: "b",
          title: "",
          type: "checkbox",
          width: 50,
          align: "center",
          fixed: "left",
          // renderBodyCell: ({ row, column, rowIndex }, h) => {
          //   return ++rowIndex;
          // }
        },
        {
          field: "index",
          key: "a",
          title: "行号",
          width: 60,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.rowKey + 1;
          },
        },

        // 表头信息
        {
          field: "barcode",
          key: "f",
          title: "商品条码",
          align: "left",
          width: 150,
          edit: true,
          fixed: "left",
          sortBy: "",
        },
        {
          field: "item_name",
          key: "item_name",
          title: "商品名称",
          align: "left",
          width: 250,
          edit: true,
          fixed: "left",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          field: "class_no",
          key: "class_no",
          title: "类别",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "sup_no",
          key: "sup_no",
          title: "供应商",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "in_price",
          key: "in_price",
          title: "进价",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "qty",
          key: "qty",
          title: "入库",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "sale_price",
          key: "sale_price",
          title: "售价",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "vip_price",
          key: "vip_price",
          title: "会员价",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "product_area",
          key: "product_area",
          title: "产地",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "unit",
          key: "unit",
          title: "单位",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "item_size",
          key: "item_size",
          title: "规格",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "grade",
          key: "grade",
          title: "等级",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "life_day",
          key: "life_day",
          title: "保质期（天）",
          align: "left",
          width: 150,
          edit: true,
        },
        {
          field: "weight_flag",
          key: "weight_flag",
          title: "称重标识",
          align: "left",
          width: 100,
          edit: true,
        },
      ],
      // table data 表格数据
      goods_list: [],
      allGoods_list: [],
      // 单元格信息
      columnsCheck: [
        // 标题第一列
        {
          field: "",
          key: "b",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        // 表头信息
        {
          field: "barcode",
          key: "f",
          title: "商品条码",
          align: "left",
          width: 100,
        },
        {
          field: "item_name",
          key: "item_name",
          title: "商品名称",
          align: "left",
          width: 300,
        },
        {
          field: "in_price",
          key: "in_price",
          title: "售价",
          align: "left",
          width: 100,
          edit: true,
        },
        {
          field: "sale_price",
          key: "sale_price",
          title: "零售价",
          align: "left",
          width: 100,
          edit: true,
        },
      ],
      // 搜索框的值
      selectInput: "",
      /* 格式化售价 */
      formatsp_data: {
        point: "",
        change_to: [0, 5, 8, 9],
      },
    };
  },
  created() {},
  mounted() {
    this.loadingInstance = this.$veLoading({
      target: document.querySelector("#loading-container"),
      // 等同于
      // target:"#loading-container"
      name: "wave",
    });

    console.log("123111111111111111111111");
    // this.loadingInstance.show();
  },
  methods: {
    getReturn({ who, value }) {
      // console.log(key);

      this.dialog_change = value;
      // this.dialogValue = "";
    },
    tagChange(key) {},
    exportXML() {
      var data = [];
      for (var i = 0; i < this.goods_list.length; i++) {
        var dataitem = {};
        for (var key in this.goods_list[i]) {
          console.log(key);
          switch (key) {
            case "barcode":
              dataitem["商品条码"] = this.goods_list[i][key];
              break;
            case "item_name":
              dataitem["商品名称"] = this.goods_list[i][key];
              break;
            case "in_price":
              dataitem["进价"] = this.goods_list[i][key];
              break;
            case "qty":
              dataitem["入库"] = this.goods_list[i][key];
              break;
            case "sale_price":
              dataitem["售价"] = this.goods_list[i][key];
              break;
            case "vip_price":
              dataitem["会员价"] = this.goods_list[i][key];
              break;
            case "vendor":
              dataitem["供应商"] = this.goods_list[i][key];
              break;
            case "class_no":
              dataitem["类别"] = this.goods_list[i][key];
              break;
            case "sup_no":
              dataitem["供应商"] = this.goods_list[i][key];
              break;
            case "product_area":
              dataitem["产地"] = this.goods_list[i][key];
              break;
            case "item_size":
              dataitem["规格"] = this.goods_list[i][key];
              break;
            case "unit":
              dataitem["单位"] = this.goods_list[i][key];
              break;
            case "grade":
              dataitem["等级"] = this.goods_list[i][key];
              break;
            case "life_day":
              dataitem["保质期"] = this.goods_list[i][key];
              break;
          }
        }
        console.log(dataitem);
        data.push(dataitem);
      }
      exportExcel(data, this.file_name);
    },
    //选中批量修改
    bindDetermine() {
      // console.log("checkedGoods的值", this.checkedGoods);
      for (var i = 0; i < this.checkedGoods.length; i++) {
        for (var j = 0; j < this.goods_list.length; j++) {
          if (this.goods_list[j].barcode == this.checkedGoods[i]) {
            this.goods_list[j][this.dialogValue] = this.dialog_change;
          }
        }
      }
      this.dialogValue = "";
      this.dialog_change = "";
      // this.bindCancelTask();
    },
    bindCancelTask() {
      this.DialogVisible = false;
      this.bulkModify = false;
    },
    //格式化售价时模态框显示
    checkModify(key) {
      if (key == "DialogVisible") {
        this.DialogVisible = true;
      } else if (key == "bulkModify") {
        this.bulkModify = true;
      }
    },
    //排序
    sortChange(params) {
      this.goods_list.sort((a, b) => {
        if (params.barcode) {
          if (params.barcode === "asc") {
            return a.barcode - b.barcode;
          } else if (params.barcode === "desc") {
            return b.barcode - a.barcode;
          } else {
            return 0;
          }
        }
      });
    },
    // 显示或者隐藏model
    // 返回两个条件选择框的value值
    searchGoods() {
      if (this.allGoods_list == []) return;
      var that = this;
      // search_value;

      if (this.search_value == "" || this.search_value.length == 0) {
        this.loadingInstance.show();
        this.goods_list = [];
        this.goods_list = this.allGoods_list;
        this.loadingInstance.close();

        return;
      } else {
        this.loadingInstance.show();
        let list = this.allGoods_list.filter((item, index) => {
          return (
            item.item_name.indexOf(that.search_value) >= 0 ||
            String(item.barcode).indexOf(that.search_value) >= 0
          );
        });
        this.goods_list = [];
        this.goods_list = list;
        this.loadingInstance.close();
      }
    },

    UploadUrl: function () {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return "";
    },
    // 保存更改导入泰格软件
    async saveUpdate() {
      // console.log(this.goods_list);
      this.loadingInstance.close();
      this.loadingInstance.show();
      var list = [];
      const goods_list = this.goods_list;
      for (let i = 0; i < goods_list.length; i++) {
        goods_list[i].in_price = goods_list[i].in_price
          ? goods_list[i].in_price
          : "0.00";
        goods_list[i].sale_price = goods_list[i].sale_price
          ? goods_list[i].sale_price
          : "0.00";

        goods_list[i].vip_price = goods_list[i].vip_price
          ? goods_list[i].vip_price
          : "0.00";
        list.push(goodsInsertItem(goods_list[i]));
      }
      const [...res] = await Promise.all(list);
      this.loadingInstance.close();
      if (this.testR(res[0])) {
        this.successMessage("商品导入成功");
      }
    },
    /* coverbtn() {
      alert(1);
    },
    updatebtn() {
      alert(2);
    }, */
    // 树形控件的方法
    handleNodeClick(data) {
      console.log(data);
    },
    // 删除选中商品
    deleteChecked() {
      console.log(this.checkedGoods.length);
      if (this.checkedGoods.length == 0) {
        this.$message({
          type: "info",
          message: "没有被选中的商品",
        });
        return;
      } else {
        this.$confirm("确定要继续执行删除操作吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            for (var j = 0; j <= this.checkedGoods.length; j++) {
              for (var i = 0; i < this.goods_list.length; i++) {
                if (this.goods_list[i].barcode == this.checkedGoods[j]) {
                  this.goods_list.splice(i, 1);
                }
              }
            }
            this.checkedGoods = [];
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //格式化售价
    formatSalePrice() {
      const array = [];
      for (let t = 0; t < this.formatsp_data.change_to.length; t++) {
        if (
          this.formatsp_data.change_to[t] !== "" ||
          this.formatsp_data.change_to[t].length != 0
        ) {
          array.push(this.formatsp_data.change_to[t]);
        }
      }
      for (let i = 0; i < this.goods_list.length; i++) {
        let sale_price = (
          Number(this.goods_list[i].in_price) /
          (1 - Number(this.formatsp_data.point) / 100)
        ).toFixed(1);

        let afterdot = String(sale_price).substring(
          sale_price.indexOf(".") + 1
        );
        let beforedot = String(sale_price).slice(
          0,
          sale_price.indexOf(".") + 1
        );
        if (array.length !== 0) {
          if (!array.includes(afterdot)) {
            let y = 0;
            let temp = Math.abs(afterdot - array[0]);
            for (let x = 0; x < array.length; x++) {
              if (Math.abs(afterdot - array[x]) < temp) {
                temp = Math.abs(afterdot - array[x]);
                y = x;
              }
            }
            afterdot = array[y];
          }
        }

        this.goods_list[i].sale_price = beforedot + afterdot;
      }
      this.bulkModify = false;
    },
    // 添加一行
    addGoods() {
      this.goods_list.push({
        barcode: "",
        item_name: "",
        class_no: "",
        sup_no: "",
        in_price: "",
        sale_price: "",
        product_area: "",
        unit: "",
        vip_price: "",
        weight_flag: "",
        grade: "",
        life_day: "",
        rowKey: this.goods_list.length,
      });
    },
    // 调用子组件的导入方法
    daoRu() {
      this.$refs.excel.showModel();
    },
    // 更新并导入获取表格组件的返回值
    updateTableData(val) {
      // 只刷新表格内容
      this.goodsDataShow = false;
      this.$nextTick(() => {
        for (var i = 0; i < val.length; i++) {
          var _index = this.goods_list.findIndex(
            (x) => x.barcode == val[i].barcode
          );
          if (_index > -1) {
            // 遍历原来就有的对象的所有导入属性
            for (var key in val[i]) {
              this.goods_list[_index][key] = val[i][key];
            }
          } else {
            val[i].rowKey = this.goods_list.length;
            this.goods_list.unshift(val[i]);
          }
        }
        this.allGoods_list = [];
        this.allGoods_list = this.goods_list;
        this.goodsDataShow = true;
      });
    },
    // 覆盖并导入数据
    CoverTableData(val) {
      console.log("覆盖并导入数据", val);
      this.goods_list = [];
      this.goodsDataShow = false;
      this.$nextTick(() => {
        for (var i = 0; i < val.length; i++) {
          var _index = this.goods_list.findIndex(
            (x) => x.barcode == val[i].barcode
          );
          if (_index > -1) {
            for (var key in val[i]) {
              this.goods_list[_index][key] = val[i][key];
            }
          } else {
            val[i].rowKey = this.goods_list.length;
            this.goods_list.push(val[i]);
          }
          this.$refs.excel.hiddleBox();
        }
        this.allGoods_list = [];
        this.allGoods_list = this.goods_list;
        this.goodsDataShow = true;
      });
    },
    FileName(file_name) {
      this.file_name = file_name;
    },
  },
};
</script>
<style scoped lang="less">
.el-button--mini {
  padding: 7px 5px;
}
.top-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 10px 0;
  height: 50px;
  .top-btn-danju {
    display: flex;
    justify-content: left;
    align-items: center;
    height: auto;
    width: auto;
    padding-left: 10px;
    border-left: 5px solid #ffbb72;
  }
}
.body-aside {
  position: absolute;
  top: 10px;
  width: 20%;
  height: 93%;
  display: inline-block;
}

.thead {
  width: 100%;
  height: 25px;
  background-color: rgb(230, 230, 230);
}
.fa {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 10px;
}
.info-btn {
  width: 50px;
  text-align: center !important;
  // padding: 12px 10px 12px 10px;
}
.upload-btn {
  width: 120px;
  margin-left: -40px;
  background-color: #008effde;
  color: #fff;
}
.submit-btn {
  position: absolute;
  width: 100px;
  top: 146px;
  left: 127px;
  z-index: 6;
  background-color: #008effde;
  color: #fff;
}
.el-upload-list {
  width: 100px;
}
.drawer-head-div {
  height: 40px;
  width: 100%;
  text-align: center;
  line-height: 2;
  color: rgb(124, 124, 124);
}
.drawer-head-div > i {
  display: inline-block;
  text-align: center;
  width: 28%;
  cursor: pointer;
}
.drawer-head-div-i {
  /* border-bottom: 4px solid #0c9d72; */
  /* background-color: ; */
  color: rgb(124, 124, 124);
  font-weight: 700;
}
.el-tree-node__content > .el-tree-node__label {
  font-size: 18px !important;
}
.ve-table-fixed-header .ve-table-header {
  background-color: #91d5ff !important;
  color: #fff !important;
}
.ve-table {
  padding: 2px !important;
  font-size: 2px;
}
.demo-drawer__footer {
  width: 100%;
  position: absolute;
  bottom: 10px;
  left: 60px;
}
.demo-drawer__footer > .el-button {
  display: inline-block;
  width: 40%;
}
.footer-btn {
  display: inline-block;
  width: 40%;
  /* margin-left: 40px; */
}
.el-input-select {
  width: 120px;
}
.right-select {
  margin: 30px 0 0 0;
}
.el-form-select {
  margin-left: -20px;
}
.select-right-drawer {
  width: 440px;
}
</style>
